import {
  type UserResponse_OutputType,
  UserRoutesRepository
} from '@shared/generated';
import { type User } from 'firebase/auth';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useUserStore = defineStore('user', () => {
  const loading = ref<boolean>(true);
  const currentS3User = ref<UserResponse_OutputType | null>(null);
  const currentAuthenticatedUser = ref<User | null>(null);
  const canUpdateCompanyInfo = computed<boolean>(() => {
    return !!currentS3User.value?.access.manage_company_info;
  });
  const canManageCompanyUsers = computed<boolean>(() => {
    return !!currentS3User.value?.access.manage_company_users;
  });

  const fetchCurrentS3User = async () => {
    try {
      loading.value = true;
      currentS3User.value = await UserRoutesRepository.userRoutesGetMeUser({});
    } finally {
      loading.value = false;
    }
  };

  const setCurrentS3User = (user: UserResponse_OutputType) => {
    currentS3User.value = user;
  };

  const setCurrentAuthenticatedUser = (user: User | null | undefined) => {
    currentAuthenticatedUser.value = user || null;
  };

  const reset = () => {
    loading.value = true;
    currentS3User.value = null;
    currentAuthenticatedUser.value = null;
  };
  return {
    loading,
    fetchCurrentS3User,
    setCurrentS3User,
    setCurrentAuthenticatedUser,
    currentS3User,
    currentAuthenticatedUser,
    canUpdateCompanyInfo,
    canManageCompanyUsers,
    reset
  };
});
